import request from '@/utils/request'

let getUserInfo=()=>request.get('/api/user/getDetail')

export default {
  getUserInfo
}